import React, { memo } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { ToastListWrapper, ToastListContent } from './styles';
import { TOAST_TRANSITION_CLASS_NAME } from 'components/Toast/styles';
import Toast from 'components/Toast';
import { INotification } from 'store/notifications/NotificationsSlice';

interface IComponentProps {
  className?: string;
  data: INotification[];
  onCloseToast: (id: string) => void;
}

const ToastList: React.FC<IComponentProps> = ({
  className,
  data,
  onCloseToast,
}: IComponentProps) => (
  <ToastListWrapper className={className}>
    <ToastListContent>
      <TransitionGroup>
        {data.map((item) => {
          return (
            <CSSTransition
              key={item.id}
              timeout={500}
              classNames={TOAST_TRANSITION_CLASS_NAME}
            >
              <Toast
                key={item.id}
                id={item.id}
                type={item.type}
                message={item.message}
                autoClose={item.autoClose}
                timeToHide={item.timeToHide}
                onClose={onCloseToast}
              />
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </ToastListContent>
  </ToastListWrapper>
);

export default memo(ToastList);
